import React from 'react';
const includes = [{
  icon: '📖',
  item: 'Guía completa Reel-Mom Estratégica (PDF + Video)',
  value: '$97'
}, {
  icon: '💬',
  item: 'Scripts de DM para conseguir clientes en frío',
  value: '$67'
}, {
  icon: '🎯',
  item: 'Guía de nichos: Real Estate, Spas, Restaurantes, Boutiques',
  value: '$47'
}, {
  icon: '💡',
  item: 'Tips para ganar más dinero: Cómo escalar de $800 a $2,000/mes',
  value: '$57'
}, {
  icon: '💲',
  item: 'Tarifas sugeridas para el mercado de USA',
  value: '$37'
}];
export function Offer() {
  return <section id="oferta" className="bg-[#fdf6ee] py-8 md:py-12" data-id="element-285">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-286">
        {/* Label */}
        <div className="text-center mb-4" data-id="element-287">
          <span className="font-dm text-xs font-bold tracking-widest text-[#c9a84c] uppercase" data-id="element-288">
            Lo que obtienes hoy
          </span>
        </div>
        <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#0d4a45] text-center leading-tight mb-12" data-id="element-289">
          Tu hoja de ruta completa para montar tu micro-agencia
        </h2>

        <div className="flex flex-col lg:flex-row gap-10 items-start" data-id="element-290">
          {/* Left: product image + includes */}
          <div className="flex-1" data-id="element-291">
            {/* Product image */}
            <div className="flex justify-center mb-8" data-id="element-292">
              <div className="relative max-w-xs w-full" data-id="element-293">
                <div className="absolute inset-0 bg-[#c9a84c]/25 rounded-2xl blur-xl scale-90 pointer-events-none" data-id="element-294" />
                <img src="https://cdn.magicpatterns.com/uploads/sYCio2eLc3TrS795cZEAQD/REEL-MOM_ESTRATEGICA.png" alt="Reel-Mom Estratégica" className="relative rounded-2xl shadow-xl w-full" data-id="element-295" />
              </div>
            </div>

            {/* Includes list */}
            <ul className="space-y-3" data-id="element-296">
              {includes.map(inc => <li key={inc.item} className="flex items-start gap-3 bg-white rounded-xl px-4 py-3 shadow-sm border border-[#0d4a45]/8" data-id="element-297">
                  <span className="text-xl shrink-0 mt-0.5" data-id="element-298">{inc.icon}</span>
                  <span className="font-dm text-[#3a3a3a] text-sm flex-1" data-id="element-299">
                    {inc.item}
                  </span>
                  <span className="font-dm text-[#5a5a5a] text-xs line-through shrink-0 mt-0.5" data-id="element-300">
                    {inc.value}
                  </span>
                </li>)}
            </ul>

            {/* Total value */}
            <div className="mt-4 flex justify-between items-center bg-[#0d4a45]/5 rounded-xl px-4 py-3" data-id="element-301">
              <span className="font-dm font-semibold text-[#0d4a45] text-sm" data-id="element-302">
                Valor total:
              </span>
              <span className="font-dm text-[#5a5a5a] text-sm line-through" data-id="element-303">
                $305 USD
              </span>
            </div>
          </div>

          {/* Right: Price box */}
          <div id="precio" className="lg:w-80 w-full shrink-0" data-id="element-304">
            <div className="bg-[#0d4a45] rounded-3xl p-7 md:p-8 border-2 border-[#c9a84c] shadow-2xl sticky top-24" data-id="element-305">
              <p className="font-dm text-white/60 text-sm text-center mb-1" data-id="element-306">
                Precio normal: $97
              </p>
              <p className="font-dm text-white/60 text-sm text-center line-through mb-4" data-id="element-307">
                $97 USD
              </p>

              <div className="text-center mb-6" data-id="element-308">
                <p className="font-dm text-[#e8a0a0] text-sm font-semibold uppercase tracking-wider mb-1" data-id="element-309">
                  HOY SOLO
                </p>
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-310">
                  <span className="font-dm text-white/50 text-2xl line-through" data-id="element-311">
                    $97
                  </span>
                  <p className="font-playfair text-6xl font-bold text-[#e8c97a]" data-id="element-312">
                    $6.36
                  </p>
                </div>
                <p className="font-dm text-white/60 text-sm mt-1" data-id="element-313">
                  USD · Pago único
                </p>
              </div>

              <p className="font-dm text-white/70 text-sm text-center italic mb-6" data-id="element-314">
                "Menos de lo que cuesta una cena fuera"
              </p>

              <a href="https://coresolutionsg.com/cart/47475437994171:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#c9a84c] hover:bg-[#e8c97a] text-[#0d4a45] font-dm font-bold text-base px-6 py-4 rounded-2xl transition-all shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 text-center mb-4" data-id="element-315">
                ✨ Quiero mi guía ahora →
              </a>

              <div className="space-y-2 text-center" data-id="element-316">
                <p className="font-dm text-white/60 text-xs" data-id="element-317">
                  🔒 Pago 100% seguro
                </p>
                <p className="font-dm text-white/60 text-xs" data-id="element-318">
                  ⚡ Acceso inmediato por email
                </p>
              </div>

              {/* Urgency */}
              <div className="mt-5 bg-[#c9a84c]/15 border border-[#c9a84c]/30 rounded-xl p-3 text-center" data-id="element-319">
                <p className="font-dm text-[#e8c97a] text-xs font-semibold" data-id="element-320">
                  ⏰ Precio sube a $97 esta semana
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}